//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
      props: ['etxaldeak', 'lan_taldea'],
      data: () => ({
        m_etxaldeak: [],
        m_lan_taldea: [],
        selectedTypes: [],
        etxaldeMap: undefined,
        cluster: undefined,
        customMarker: undefined,
      }),
      computed:{
        find(){
          if(this.selectedTypes.length == 0) return this.m_etxaldeak
            
          return this.m_etxaldeak.filter((i) =>     
            i.lan_taldea.some(r => this.selectedTypes.includes(r))                         
          )
        }
      },
      methods:{
         selectType(name)
         {
           let found = this.selectedTypes.indexOf(name);
           if(found === -1)
           {
            this.selectedTypes.push(name);
           }
           else
           {
             let saco = this.selectedTypes.splice(found, 1);
           }
          this.initMap()
         },
         initMap()
         {
            let info, cont = 0;
            let marker = []
            this.cluster.clearLayers()
            this.find.forEach(etxaldea => {                         
              if(etxaldea.lat != "" && etxaldea.lat != null)
              {                  
                info = "<b>"+etxaldea.post_title+"</b><br>"+etxaldea.izena+" "+etxaldea.abizena+"<br>"+ etxaldea.telefonoa
                marker[cont] = L.marker([parseFloat(etxaldea.lat), parseFloat(etxaldea.lon)], {icon: this.customMarker}).bindPopup(info)
                this.cluster.addLayer( marker[cont++] )  
              }
          });
          
          this.etxaldeMap.addLayer(this.cluster);
         }

      
      },
      mounted(){          
        this.m_lan_taldea = JSON.parse(this.lan_taldea)          
        this.m_etxaldeak = JSON.parse(this.etxaldeak)
          const tilesProvider = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          this.etxaldeMap = L.map('etxaldeMap').setView([43.1862, -1.8059], 9)
          this.cluster = L.markerClusterGroup();
          L.tileLayer(tilesProvider, {
            maxZoom: 18,
            minZoom:  1,
            ext: 'png'

          }).addTo(this.etxaldeMap)
          
          this.customMarker = L.ExtraMarkers.icon({
            icon: 'fa-home',
            markerColor: 'green',
            shape: 'square',
            prefix: 'fa'
          })


          this.initMap()

      }
  }



// WEBPACK FOOTER //
// ./scripts/vue/etxaldemapa.vue